
export enum ProRequestStatusCd {
	CANCEL = 'Cancel',
	COMPLETED = 'Completed',
	IN_PROCESS = 'InProcess',
	NEW = 'New'}

